import { App } from 'vue';

import {
  ElPopover,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElScrollbar,
  ElSteps,
  ElStep,
} from 'element-plus';

// Required for the popper
import 'element-plus/packages/theme-chalk/src/popper.scss';

const configElementPlus = (app: App) => {
  app.component('ElPopover', ElPopover);
  app.component('ElDropdown', ElDropdown);
  app.component('ElDropdownItem', ElDropdownItem);
  app.component('ElDropdownMenu', ElDropdownMenu);
  app.component('ElScrollbar', ElScrollbar);
  app.component('ElSteps', ElSteps);
  app.component('ElStep', ElStep);
};

export default configElementPlus;
